import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  FiHome,
  FiMessageSquare,
  FiUser,
  FiLogOut,
  FiMenu,
  FiX,
  FiSend,
} from "react-icons/fi";
import logo from "../../src/assets/images/innercircle.png";

const LifeSaverLayout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/member/login");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div>
      {/* Mobile Header */}
      <div className="mobile-header">
        <button className="hamburger-btn" onClick={toggleSidebar}>
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
        <div className="mobile-header-logo">
          <img
            alt="logo"
            className="mx-auto"
            src={logo}
            style={{ width: 80, height: 80, objectFit: "contain" }}
          />
          {/* <span>Member Portal</span> */}
        </div>
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      <aside className={`sidebar ${isSidebarOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-header text-center">
          <img
            alt="logo"
            src={logo}
            style={{ width: 150, height: 120, objectFit: "contain" }}
          />
          {/* <div className="sidebar-logo">Inner Circle</div> */}
          {/* <div className="sidebar-subtitle">Member Portal</div> */}
        </div>

        <nav>
          <ul className="sidebar-nav">
            <li>
              <NavLink
                to="/member/dashboard"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeSidebar}
              >
                <FiHome size={20} />
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/member/communications"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeSidebar}
              >
                <FiMessageSquare size={20} />
                Communications
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/member/contact-admin"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeSidebar}
              >
                <FiSend size={20} />
                Contact Admin
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/member/profile"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeSidebar}
              >
                <FiUser size={20} />
                My Profile
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          {/* <div
            style={{
              marginBottom: "1rem",
              color: "rgba(255,255,255,0.6)",
              fontSize: "0.875rem",
            }}
          >
            <FiUser style={{ marginRight: "0.5rem" }} />
            {user?.fullName || user?.email}
          </div> */}
          <button className="logout-btn" onClick={handleLogout}>
            <FiLogOut size={20} />
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content">{children}</main>
    </div>
  );
};

export default LifeSaverLayout;
